$(function(){

	// console.log('slick is ready');

	if( $('.content_slider .slide').length > 1 ){
		$('.content_slider').slick({
			rows: 0,
			infinite: true,
			slidesToShow: 1,
			fade: true,
			dots: true,
			arrows: true,
			adaptiveHeight: true
		});
	}
	
	$('.banner.image.home').slick({
		rows: 0,
		infinite: true,
		slidesToShow: 1,
		fade: true,
		dots: true,
		arrows: false,
		adaptiveHeight: false,
		autoplay: true,
		autoplaySpeed: 2000,
	});

	$('.tileslider').slick({
		rows: 0,
		infinite: true,
		// slidesToShow: 5,
		fade: false,
		dots: true,
		arrows: false,
		adaptiveHeight: false,
		slidesToScroll: 1,
		autoplay: false,
		autoplaySpeed: 5000,
		variableWidth: true,
		responsive: [
		{
			breakpoint: 470,
			settings: {
				centerMode: true,
			}
		}
		]
	});

	
	$('.slider_with_thumbs2').slick({
		autoplay: true,
		arrows: false,
	    dots: true,
	    fade: true,
	    customPaging : function(slider, i) {
	        var thumb = $(slider.$slides[i]).find('.slide_element img').attr('src')
	        return '<a><img src="'+thumb+'"></a>';
	    },
	});

	// Responsive Slick Slider
	// $('.parent-container').slick({
	// 	slide: '.slide',
	// 	row: 0,
	// 	infinite: true,
	// 	slidesToShow: 3,
	// 	slidesToScroll: 3,
	// 	dots: true,
	// 	arrows: false
	// 	responsive: [
	// 	    {
	// 	      breakpoint: 768,
	// 	      settings: {
	// 	        arrows: false,
	// 	        centerMode: true,
	// 	        centerPadding: '40px',
	// 	        slidesToShow: 2
	// 	      }
	// 	    },
	// 	    {
	// 	      breakpoint: 480,
	// 	      settings: {
	// 	        arrows: false,
	// 	        centerMode: true,
	// 	        centerPadding: '40px',
	// 	        slidesToShow: 1
	// 	      }
	// 	    }
	//   	]
	// });

});
